export const convertToNumbers = (value?: string) =>
  value?.replace(/[^0-9]/g, '');
